<template>
  <svg
    viewBox="0 0 24 25"
    fill="none"
    stroke="currentColor"
    :class="customStyle"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_147_7063)">
      <path
        d="M23.25 21.7055L21.76 19.4705V14.2205C21.76 12.2205 17.96 10.0805 16.51 8.97046"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.44 15.5135L14.792 12.5905C14.5476 12.3461 14.2161 12.2088 13.8705 12.2088C13.5248 12.2088 13.1934 12.3461 12.949 12.5905C12.7046 12.8349 12.5673 13.1664 12.5673 13.512C12.5673 13.8576 12.7046 14.1891 12.949 14.4335L16.482 18.4205V20.9205C16.482 22.1015 18.17 23.9655 18.17 23.9655"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.51 22.4705H2.13401C1.76951 22.4702 1.42003 22.3253 1.16238 22.0674C0.904738 21.8096 0.76001 21.46 0.76001 21.0955V2.84446C0.76001 2.48005 0.90477 2.13057 1.16245 1.8729C1.42012 1.61522 1.7696 1.47046 2.13401 1.47046H15.134C15.3146 1.47033 15.4934 1.50576 15.6603 1.57474C15.8271 1.64372 15.9788 1.74489 16.1066 1.87248C16.2343 2.00007 16.3357 2.15157 16.405 2.31835C16.4742 2.48512 16.5099 2.66389 16.51 2.84446V13.9675"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.76001 4.47046H12.76V7.47046"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.76 4.47046L3.76001 12.7205"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25 16.4705V19.4705"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.25 14.2205V19.4705"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_147_7063">
        <rect
          width="24"
          height="24"
          fill="currentColor"
          transform="translate(0 0.720459)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'ReportIcon',
  props: {
    customStyle: {
      type: String,
      default: 'w-5 h-5',
    },
  },
}
</script>
